import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import logo from './../../assets/icons/Variant=ARIS Robotics, Colour=Green.svg';
import { redeemWelcomeLink } from '../../common/welcomeEmailApi.js';
import './../../App.css';
import './../LoginPage/LoginPage.css';
import './../SignupPage/SignupPage.css';
import './WelcomePage.css';

// Every refusal the redeem function can give, by `details.reason`. An unknown token reads the
// same as any other invalid link, so the page never confirms that a token exists.
export const WELCOME_ERROR_MESSAGES = {
    invalid: 'Linket er ugyldigt. Kontakt ARIS Robotics.',
    retired: 'Der er sendt en nyere velkomstmail til dig. Brug linket i den nyeste mail.',
    expired: 'Linket er udløbet. Kontakt ARIS Robotics for at få et nyt.',
    internal: 'Noget gik galt. Prøv igen, eller kontakt ARIS Robotics.',
};

// The page a Welcome Link opens. It mints a fresh password reset link only when the person
// asks for it, so the short-lived Firebase link never sits waiting in an inbox.
const WelcomePage = () => {
    const { token } = useParams();
    const [state, setState] = useState('ready');
    const [error, setError] = useState(null);

    const choosePassword = async () => {
        setState('working');
        setError(null);
        try {
            const { reset_link: resetLink } = await redeemWelcomeLink(token);
            window.location.assign(resetLink);
        } catch (redeemError) {
            const reason = redeemError?.details?.reason;
            if (reason === 'done') {
                setState('done');
                return;
            }
            setError(WELCOME_ERROR_MESSAGES[reason] || WELCOME_ERROR_MESSAGES.internal);
            setState('ready');
        }
    };

    return (
        <div className="LoginPage SignupPage WelcomePage">
            <img className="main-logo" src={logo} alt="Aris Robotics" />
            <div className="login-container card-container">
                <div className="card-header">
                    <div className="card-header-title">Velkommen</div>
                </div>
                {state === 'done' ? (
                    <div className="card-body">
                        <p>Du har allerede valgt en adgangskode. Log ind med din email og adgangskode.</p>
                        <div className="card-actions">
                            <a className="aris-button-primary signup-destination" href="/">
                                Gå til log ind
                            </a>
                        </div>
                    </div>
                ) : (
                    <div className="card-body">
                        <p>Der er oprettet en bruger til dig hos ARIS Robotics. Vælg en adgangskode for at komme i gang.</p>
                        <div className="card-actions">
                            <div className="login-error" role="alert">{error}</div>
                            <button
                                className="aris-button-primary"
                                type="button"
                                onClick={choosePassword}
                                disabled={state === 'working'}
                            >
                                Vælg adgangskode
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default WelcomePage;
